import { api } from '../../../system/api'

export default {
    getBagLastmileDetail: id => api.get(`lastmile-bags/${id}`),
    packingBagLastmile: (id, data) => api.post(`lastmile-bags/${id}/packing`, data),
    packingBagLastmileComplete: id => api.post(`lastmile-bags/${id}/packing-complete`, {}),
    packingBagLastmileDelete: (id, data) => api.post(`lastmile-bags/${id}/remove-packing`, data),
    printStampBagLastmile: (id) => api.get(`lastmile-bags/${id}/print-stamp`, {}),
}
